import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { getFullAddress } from 'utils/filters';
import { useBeneficiarySellModal } from '../context/BeneficiarySellModalContext';

const BeneficiaryDataView: FC = () => {
  const { t } = useTranslate();

  const { data } = useBeneficiarySellModal();

  const beneficiaryName = data.beneficiary?.name || '';
  const beneficiaryCif = data.beneficiary?.cif || '';
  const beneficiaryAddress = getFullAddress(data.beneficiary?.address) || '';
  const beneficiaryEmail = data.beneficiary?.email || '';

  return (
    <div className="invoice-contact col-12 col-md-6 mb-4 mb-md-0 d-print-inline-block">
      <span className="overline-title">{t('Beneficiary')}</span>

      <div className="invoice-contact-info">
        <h5 className="title">{beneficiaryName}</h5>
        <ul className="list-plain d-flex flex-column mt-3">
          <li className="d-inline-flex">
            <em className="icon ni ni-wallet" />
            <span>{beneficiaryCif}</span>
          </li>
          <li className="d-inline-flex">
            <em className="icon ni ni-map-pin-fill" />
            <span>{beneficiaryAddress}</span>
          </li>
          <li className="d-inline-flex">
            <em className="icon ni ni-mail" />
            <span>{beneficiaryEmail}</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default BeneficiaryDataView;
